import React, { Fragment, useState, useEffect } from 'react';
import { string } from 'prop-types';
import axios from 'axios';

import FullSizeLoader from '../../react-components/full-size-loader';

import { constEvent } from '../../utils/constants';

import DefaultView from './default-view';
import SuccessView from './success-view';

const AddToCart = ({
  endpointFetchLists,
  endpointAddList,
  labelExistingList,
  placeholderSelectLists,
  placeholderNoExistingLists,
  labelNewList,
  newListCharacterLimit,
  newListCharacterLimitMessage,
  btnLabelSave,
  btnLabelCancel,
  btnLabelOk,
  labelSuccessMessage
}) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const [productId, setProductId] = useState('');
  const [dropdownOptions, setDropdownOptions] = useState(null);

  useEffect(() => {
    document._on(
      constEvent.LOAD_ADD_TO_LIST_VIEW,
      loadAddToListView.bind(this)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetState = () => {
    setIsSuccess(false);
    setIsLoading(true);
    setErrorMessage(null);
    setProductId('');
    setDropdownOptions(null);
  }; //resetState

  const loadAddToListView = event => {
    resetState();

    setProductId(event?.detail || '');

    fetchLists();
  }; //loadAddToListView

  const fetchLists = () => {
    axios({
      method: 'get',
      url: endpointFetchLists,
      headers: {
        'content-type': 'application/json'
      }
    })
      .then(response => {
        const { success, body, message } = response?.data || {};

        if (success) {
          setDropdownOptions(body?.options || []);
        } else {
          setErrorMessage(message);
        }
      })
      .catch(error => setErrorMessage(error?.message))
      .finally(() => setIsLoading(false));
  }; //fetchLists

  const handleUpdateLoadingState = newState => setIsLoading(newState);

  const handleUpdateSuccessState = newState => setIsSuccess(newState);

  const propsDefaultView = {
    endpointAddList,
    labelExistingList,
    placeholderSelectLists,
    labelNewList,
    btnLabelSave,
    btnLabelCancel,
    placeholderNoExistingLists,
    newListCharacterLimit,
    newListCharacterLimitMessage,
    productId,
    dropdownOptions,
    cbUpdateLoadingState: handleUpdateLoadingState,
    cbUpdateSuccessState: handleUpdateSuccessState
  }; //propsDefaultView

  const propsSuccess = {
    btnLabelOk,
    labelSuccessMessage
  }; //propsSuccess

  return (
    <div className="modal-add-to-list__wrapper">
      {isLoading ? <FullSizeLoader /> : null}

      {errorMessage ? (
        <p dangerouslySetInnerHTML={{ __html: errorMessage }} />
      ) : (
        <Fragment>
          {isSuccess ? (
            <SuccessView {...propsSuccess} />
          ) : (
            <DefaultView {...{ ...propsDefaultView }} />
          )}
        </Fragment>
      )}
    </div>
  );
};

AddToCart.propTypes = {
  endpointFetchLists: string.isRequired,
  endpointAddList: string.isRequired,
  labelExistingList: string.isRequired,
  placeholderSelectLists: string.isRequired,
  placeholderNoExistingLists: string.isRequired,
  labelNewList: string.isRequired,
  newListCharacterLimit: string.isRequired,
  newListCharacterLimitMessage: string.isRequired,
  btnLabelSave: string.isRequired,
  btnLabelCancel: string.isRequired,
  btnLabelOk: string.isRequired,
  labelSuccessMessage: string.isRequired
};

export default AddToCart;
